import { Link } from 'react-router';
import { useT, useTurl } from '~/util/Lang';

import css from "./CraftLink.module.css";
import { Icon24 } from '../ui/Icon';

export function CraftLink(params: { recId: number; }) {
  const turl = useTurl();
  const t = useT();

  return <Link className={css.craftLink} to={turl(`/craft/calc/?items=${params.recId}`)}>
    <Icon24 icon='skill0172' alt="craft" />
    <span>{t({ en: "Craft Calculator", ru: "Калькулятор крафта" })}</span>
  </Link>;
}